export default "__VITE_ASSET__DNwr22yi__"